import { Box } from '@mui/material';
import { useContext, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import ApplicationBody from '@/components/application_components/ApplicationBody';
import ApplicationHeader from '@/components/application_components/header/ApplicationHeader';
import { Spinner } from '@/components/common/Spinner';
import DeadlineBanner from '@/components/dashboard_components/applicant_dashboard/DeadlineBanner';
import Header from '@/components/header/Header';
import {
  CurrentApplicationContext,
  CurrentApplicationProvider,
} from '@/Contexts/CurrentApplicationContext';
import { LocaleContext } from '@/Contexts/LocaleContext';

function ApplicationContent() {
  const { currentStandardInfo, applicationLoading } = useContext(CurrentApplicationContext);
  const { locale } = useContext(LocaleContext);

  const canRenderTheApplication = !applicationLoading && locale != null;

  const scrollableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (currentStandardInfo?.standardId != null && scrollableRef.current != null) {
      scrollableRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [currentStandardInfo?.standardId]);

  return (
    <Box display='flex' flexDirection='column' height='100vh' width='100vw'>
      <DeadlineBanner />
      <Header />
      {!canRenderTheApplication ? (
        <Spinner />
      ) : (
        <Box
          ref={scrollableRef}
          sx={{
            overflowX: 'hidden',
            scrollbarGutter: 'stable',
            width: '100vw',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              width: '1400px',
            }}
          >
            <ApplicationHeader />
            <ApplicationBody />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default function Application() {
  const { appid } = useParams();

  return (
    <CurrentApplicationProvider key={appid} appid={appid}>
      <ApplicationContent />
    </CurrentApplicationProvider>
  );
}
